<template>
  <Dialog v-model:open="dialogOpen">
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{{ title }}</DialogTitle>
      </DialogHeader>
      <div class="tw:px-6">
        <p v-for="line in textLines">
          {{ line }}
        </p>
      </div>
      <DialogFooter>
        <button v-for="button in buttons" type="button" class="btn" :class="button.class" @click="button.click">
          {{ button.text }}
        </button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script>
import { bus } from '@/common/setup-app/event-bus.js'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shadcn/components/ui/dialog/index.js'

export default {
  name: 'BootModal',
  components: {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
  },
  data() {
    return {
      dialogOpen: false,
      title: '',
      text: '',
      buttons: [],
    }
  },
  computed: {
    textLines() {
      return this.text.split('\n')
    },
  },
  created() {
    bus.$on('show-boot-modal', (options) => {
      this.title = options.title
      this.text = options.text
      this.buttons = options.buttons
      this.dialogOpen = true
    })
    bus.$on('hide-boot-modal', () => {
      this.dialogOpen = false
    })
  },
}
</script>
